import { ADD_DOMAIN, ADD_DOMAIN_FAILED, ADD_DOMAIN_SUCCESS, BULKIMPORT_DOMAINS, BULKIMPORT_DOMAINS_FAILED, BULKIMPORT_DOMAINS_SUCCESS, DOMAIN_DELETE, DOMAIN_DELETE_FAILED, DOMAIN_DELETE_SUCCESS, GET_DOMAINS, GET_DOMAINS_FAILED, GET_DOMAINS_SUCCESS, GET_SAMPLE_DOMIANS_CSV, GET_SAMPLE_DOMIANS_CSV_FAILED, GET_SAMPLE_DOMIANS_CSV_SUCCESS, UPDATE_DOMAIN_SUCCESS } from "./actionTypes";


const initialState = {
    loading: false,
    domainData:null,
    domainDataError:null,
    deleteDomain:null,
    deleteDomainError:null,
    addDomainData:null,
    addDomainError:null,
    updateDomainData:null,
    sampleCsv: null,
    bulkImportResult: null,
    bulkImportResultFailed:null

}

const DomainConfiguration = (state = initialState, action) => {
    switch (action.type) {
        case GET_DOMAINS :
        state = {
            ...state,
            loading:true,
            domainData: null,
            domainDataError: null
        }
        break
        case GET_DOMAINS_SUCCESS :
            state = {
                ...state,
                loading:false,
                domainData: action.payload,
                domainDataError: null
            }
            break
            case GET_DOMAINS_FAILED :
                state = {
                    ...state,
                    loading:false,
                    domainData:null ,
                    domainDataError: action.payload
                }
                break
            case DOMAIN_DELETE :
                state = {
                    ...state,
                    loading:true,
                    deleteDomain: null,
                    deleteDomainError: null
                }
                break
            case DOMAIN_DELETE_SUCCESS :
                    state = {
                ...state,
                loading:false,
                deleteDomain: action.payload,
                deleteDomainError: null
                 }
                break
            case DOMAIN_DELETE_FAILED :
                    state = {
                        ...state,
                        loading:false,
                        deleteDomain:null ,
                        deleteDomainError: action.payload
                    }
                break
                case ADD_DOMAIN :
                state = {
                    ...state,
                    loading:true,
                    updateDomainData:null,
                    addDomainData: null,
                    addDomainError: null
                }
                break
            case ADD_DOMAIN_SUCCESS :
                    state = {
                ...state,
                loading:false,
                addDomainData: action.payload,
                addDomainError: null
                 }
                break
            case ADD_DOMAIN_FAILED :
                    state = {
                        ...state,
                        loading:false,
                        addDomainData:null ,
                        updateDomainData:null,
                        addDomainError: action.payload
                    }
                break
                case UPDATE_DOMAIN_SUCCESS :
                    state = {
                ...state,
                loading:false,
                updateDomainData: action.payload,
                addDomainError: null
                 }
                break

                case GET_SAMPLE_DOMIANS_CSV:
      state = {
        ...state,
        sampleCsv: null,
      };
      break;
    case GET_SAMPLE_DOMIANS_CSV_SUCCESS:
      state = {
        ...state,
        sampleCsv: action.payload,
      };
      break;
    case GET_SAMPLE_DOMIANS_CSV_FAILED:
      state = {
        ...state,
        sampleCsv: null,
      };
      break;
    case BULKIMPORT_DOMAINS:
      state = {
        ...state,
        bulkImportResult: null,
        bulkImportResultFailed:null
      };
      break;
    case BULKIMPORT_DOMAINS_SUCCESS:
      state = {
        ...state,
        bulkImportResult: action.payload,
        bulkImportResultFailed:null
      };
      break;
    case BULKIMPORT_DOMAINS_FAILED:
      state = {
        ...state,
        bulkImportResult: null,
        bulkImportResultFailed:action.payload
      };
      break;
        default:
            state = { ...state }
            break


    }
return state;
}


export default DomainConfiguration
